/**
 * ehr#736 (Jay 10-31): "Don't let anyone delete anything from the chart. They can archive only."
 * The shared bits for every chart list (Contact Notes, Files, Forms, Tasks): the Archive and Restore
 * icons and the "Show archived" switch. An archived item is hidden until the switch is on; it then
 * lists greyed with a Restore button. Nothing is deleted.
 */

export const ArchiveIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <rect x="2" y="3" width="20" height="5" rx="1" />
    <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" />
    <line x1="10" y1="12" x2="14" y2="12" />
  </svg>
);

export const RestoreIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <polyline points="1 4 1 10 7 10" />
    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
  </svg>
);

/** The "Show archived" switch above (or below) a chart list. */
export function ShowArchivedToggle({
  on,
  onChange,
  count,
}: {
  on: boolean;
  onChange: (on: boolean) => void;
  /** How many archived items there are, once loaded (shown as "Show archived (3)"). */
  count?: number;
}) {
  return (
    <label className="show-archived">
      <input type="checkbox" checked={on} onChange={(e) => onChange(e.target.checked)} />
      Show archived{on && count !== undefined ? ` (${count})` : ''}
    </label>
  );
}

/** The Restore button on an archived row. */
export function RestoreButton({
  onClick,
  disabled,
  label = 'Restore',
}: {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <button type="button" className="btn sm restore-btn" onClick={onClick} disabled={disabled}>
      <RestoreIcon /> {label}
    </button>
  );
}
